<template>
  <li class="list-item repair" :class="{'has-cid': $route.name==='allVis' && cId}">
    <x-angleIcon></x-angleIcon>
    <h3><i class="iconfont iconicon_jiantou"></i>报修统计</h3>
    <div class="tongji iconfont iconicon_tongji"></div>
    <div id="repair"></div>
  </li>
</template>

<script>
import chartOpt from '@/utils/chartOptions';
export default {
  name: 'repair',
  data () {
    return {
      cId: '',
      repair: {}
    };
  },
  created () {
    console.log('route: ', this.$route.name);
    this.getDataViewQuery(this);
  },
  mounted () {
    this.repairChart();
  },
  methods: {
    /* 饼状图报事、保修回复状态的统计 */
    repairChart () {
      this.repair = this.Highcharts.chart('repair', chartOpt.repairOptions);
      this.repairData();
    },
    /* 获取报修统计 */
    repairData () {
      this.$get({
        url: '/zw_statistics/repair_statistics',
        params: {community_id: this.cId},
        config: { timeout: 20000 }
      }).then(({data}) => {
        const noAnswerNum = data.no_answer_num === undefined ? 0 : data.no_answer_num;
        const answerNum = data.answer_num === undefined ? 0 : data.answer_num;
        let arr = [
          { name: '待回复', y: data.no_answer, z: data.no_answer, num: noAnswerNum },
          { name: '已回复', y: data.answer, z: data.answer, num: answerNum }
        ];
        this.repair.series[0].setData(arr);
      });
    }
  }
};
</script>

<style lang="scss" scoped>
  .has-cid {
    height: 21.5vh;
  }
</style>
